module.exports = __webpack_public_path__ + "static/media/p4_image2.f5e38e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/p4_image2.png
// module id = 2522
// module chunks = 0